import clsx from 'clsx'
import { useState } from 'react'
import { Link } from 'react-router-dom'

import mainStyles from 'assets/css/main.module.scss'
import Cross from 'assets/icons/cross.svg'
import { ReactComponent as ExternalLink } from 'assets/icons/external-link-icon.svg'
import Infinity from 'assets/icons/infinity.gif'
import Arrow from 'assets/icons/right_arrow.svg'
import Bubble from 'components/common/bubble/Bubble'
import Circle from 'components/common/circle/Circle'
import TitleText from 'components/common/titleText/TitleText'
import { Icon } from 'components/uikit/Icon/Icon'
import { Typography } from 'components/uikit/Typography/Typography'
import { AnalyticsActionType } from 'types/common/analytics.type'
import { EVENTS, trackAnalytics } from 'utils/analytics'

import { PartnersData } from './PartnersData'
import styles from './PartnersSubhead.module.scss'
import { Flex } from '../common/flex/Flex'

const title = 'Cross-Functional Partners'
const text = 'Find key players, experts and MVPs in making experiences come to life.'
const bubbleText = 'Hey Besties'

const PartnersSubhead = () => {
  const [openDropdown, setOpenDropdown] = useState(false)

  const handleOpenDropdown = () => {
    if (!openDropdown) setOpenDropdown(true)

    trackAnalytics({
      type: AnalyticsActionType.action,
      payload: EVENTS.ACTION.EXPLOOP_CFP('expandcard'),
    })
  }

  const handleCloseDropdown = () => {
    if (openDropdown) setOpenDropdown(false)

    trackAnalytics({
      type: AnalyticsActionType.action,
      payload: EVENTS.ACTION.EXPLOOP_CFP('minimizecard'),
    })
  }

  return (
    <div className={clsx(mainStyles.container, 'w-full')}>
      <Flex className={styles.containerWrapper} onClick={handleOpenDropdown}>
        <div className={styles.leftImageContainer}>
          <img src={Infinity} alt="" />
        </div>
        <div className={styles.rightTextContainer}>
          <h2 className={styles.title}>{title}</h2>
        </div>
        <Circle
          className={clsx(styles.circle, openDropdown ? styles.hide : styles.circleAnimation)}
          text="Make new friends"
          textOnHover="Explore Partners"
        />
        <div className={styles.arrowContainer}>
          <img src={Arrow} alt="" />
        </div>
        <Flex direction="column" className={clsx(styles.dropdownContainer, openDropdown && styles.active)}>
          <div className={styles.leftImageContainer}>
            <img src={Infinity} alt="" />
          </div>
          <TitleText
            containerClassName={styles.dropdownTitleContainer}
            titleClassName={styles.dropdownTitle}
            textClassName={styles.dropdownText}
            titleTag="h3"
            textTag="p"
            titleType="5xl-display"
            textType="l-body"
            title={title}
            text={text}
          >
            <Bubble color="#EBFF00" text={bubbleText} className={styles.bubble} direction="down" />
          </TitleText>
          <Flex direction="row" gap={39}>
            {PartnersData.map(partner => {
              return (
                <Flex key={partner.title} direction="column" className={styles.cardItem}>
                  <div>
                    <img src={partner.img} alt="" />
                  </div>
                  <TitleText
                    titleType="m-body"
                    titleTag="p"
                    textType="m-body"
                    textTag="p"
                    title={partner.title}
                    text={partner.description}
                    textClassName={styles.dropdownContentText}
                    titleClassName={styles.dropdownContentTitle}
                    containerClassName={styles.dropdownTextContainer}
                  />
                  {partner.link && (
                    <Link to={partner.link} className={styles.link} target="_blank">
                      <Typography type="s-body" className={styles.linkText}>
                        Learn More
                      </Typography>
                      <Icon icon={ExternalLink} color="#ffffff" />
                    </Link>
                  )}
                </Flex>
              )
            })}
          </Flex>
          <div className={styles.rightImageContainer} onClick={handleCloseDropdown}>
            <img src={Cross} alt="" />
          </div>
        </Flex>
      </Flex>
    </div>
  )
}

export default PartnersSubhead
